import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { truncateMiddle } from '../../../common';
import { useFileSizeFormatter } from '../../../common/hooks';
import downloadIcon from '../../../assets/images/download.svg';
import { WidgetContext } from '../../../components/App';
import * as styles from './ArticleFiles.module.css';
export const ArticleFiles = ({ files }) => {
    const { widgetSettings } = useContext(WidgetContext);
    const formatFileSize = useFileSizeFormatter();
    const linkDomain = widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.host;
    if (!linkDomain)
        return null;
    return (_jsxs("div", { className: styles.files, children: [_jsx("span", { className: styles.filesTitle, children: files.length > 0 && _jsx(FormattedMessage, { id: 'files' }) }), files.map((file, index) => (_jsxs("a", { href: `https://${linkDomain}${file.link}`, target: '_blank', rel: 'noreferrer', className: styles.fileLinkWrapper, children: [_jsxs("div", { className: styles.file, children: [_jsx("span", { className: styles.fileName, children: truncateMiddle(file.original_name, 20) }), _jsxs("span", { className: styles.fileSize, children: ["(", formatFileSize(file.file_size), ")"] })] }), _jsx("img", { src: downloadIcon, alt: 'download icon', draggable: 'false' })] }, index)))] }));
};
